import { ADMIN_BRANCH_DELETE_FAIL, ADMIN_BRANCH_DELETE_REQUEST, ADMIN_BRANCH_DELETE_SUCCESS, ADMIN_BRANCH_EDIT_FAIL, ADMIN_BRANCH_EDIT_REQUEST, ADMIN_BRANCH_EDIT_SUCCESS, ADMIN_BRANCH_LIST_FAIL, ADMIN_BRANCH_LIST_REQUEST, ADMIN_BRANCH_LIST_SUCCESS, ADMIN_BRANCH_SAVE_FAIL, ADMIN_BRANCH_SAVE_REQUEST, ADMIN_BRANCH_SAVE_SUCCESS, ADMIN_BRANCH_SAVE_VALIDATION, ADMIN_BRANCH_UPDATE_FAIL, ADMIN_BRANCH_UPDATE_REQUEST, ADMIN_BRANCH_UPDATE_SUCCESS, ADMIN_BRANCH_UPDATE_VALIDATION, ADMIN_DELETE_FAIL, ADMIN_DELETE_REQUEST, ADMIN_DELETE_SUCCESS, ADMIN_EDIT_FAIL, ADMIN_EDIT_REQUEST, ADMIN_EDIT_SUCCESS, ADMIN_LIST_FAIL, ADMIN_LIST_REQUEST, ADMIN_LIST_SUCCESS, ADMIN_SAVE_FAIL, ADMIN_SAVE_REQUEST, ADMIN_SAVE_SUCCESS, ADMIN_SAVE_VALIDATION, ADMIN_UPDATE_FAIL, ADMIN_UPDATE_REQUEST, ADMIN_UPDATE_SUCCESS, ADMIN_UPDATE_VALIDATION, ADVISERALL_LIST_FAIL, ADVISERALL_LIST_REQUEST, ADVISERALL_LIST_SUCCESS, ADVISER_DELETE_FAIL, ADVISER_DELETE_REQUEST, ADVISER_DELETE_SUCCESS, ADVISER_EDIT_FAIL, ADVISER_EDIT_REQUEST, ADVISER_EDIT_SUCCESS, ADVISER_LIST_FAIL, ADVISER_LIST_REQUEST, ADVISER_LIST_SUCCESS, ADVISER_SAVE_FAIL, ADVISER_SAVE_REQUEST, ADVISER_SAVE_SUCCESS, ADVISER_SAVE_VALIDATION, ADVISER_UPDATE_FAIL, ADVISER_UPDATE_REQUEST, ADVISER_UPDATE_SUCCESS, ADVISER_UPDATE_VALIDATION, OFFICEALL_LIST_FAIL, OFFICEALL_LIST_REQUEST, OFFICEALL_LIST_SUCCESS, PRINCIPAL_BY_OFFICE_LIST_FAIL, PRINCIPAL_BY_OFFICE_LIST_REQUEST, PRINCIPAL_BY_OFFICE_LIST_SUCCESS, PRINCIPAL_DELETE_FAIL, PRINCIPAL_DELETE_REQUEST, PRINCIPAL_DELETE_SUCCESS, PRINCIPAL_EDIT_FAIL, PRINCIPAL_EDIT_REQUEST, PRINCIPAL_EDIT_SUCCESS, PRINCIPAL_LIST_FAIL, PRINCIPAL_LIST_REQUEST, PRINCIPAL_LIST_SUCCESS, PRINCIPAL_SAVE_FAIL, PRINCIPAL_SAVE_REQUEST, PRINCIPAL_SAVE_SUCCESS, PRINCIPAL_SAVE_VALIDATION, PRINCIPAL_UPDATE_FAIL, PRINCIPAL_UPDATE_REQUEST, PRINCIPAL_UPDATE_SUCCESS, PRINCIPAL_UPDATE_VALIDATION,CSM_DELETE_FAIL, CSM_DELETE_REQUEST, CSM_DELETE_SUCCESS, CSM_EDIT_FAIL, CSM_EDIT_REQUEST, CSM_EDIT_SUCCESS, CSM_LIST_FAIL, CSM_LIST_REQUEST, CSM_LIST_SUCCESS, CSM_SAVE_FAIL, CSM_SAVE_REQUEST, CSM_SAVE_SUCCESS, CSM_SAVE_VALIDATION, CSM_UPDATE_FAIL, CSM_UPDATE_REQUEST, CSM_UPDATE_SUCCESS, CSM_UPDATE_VALIDATION, } from '../constants/memberConstants'
import { message } from 'antd'

const initialState = {
  validation: [],
}

const key = 'updatable';

export const officeAllListReducer = (state = {listsOffice:[]}, action) => {
  switch (action.type) {
    case OFFICEALL_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case OFFICEALL_LIST_SUCCESS:
      return{ ...state, loading: false, listsOffice: action.payload.data }
    case OFFICEALL_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adviserAllListReducer = (state = {listsAllAdviser:[]}, action) => {
  switch (action.type) {
    case ADVISERALL_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ADVISERALL_LIST_SUCCESS:
      return{ ...state, loading: false, listsAllAdviser: action.payload.data }
    case ADVISERALL_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

//=================================  Adviser  ============================================

export const adviserListReducer = (state = {adviser:[], listsAdviser:[]}, action) => {
  switch (action.type) {
    case ADVISER_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ADVISER_LIST_SUCCESS:
      return{ ...state, loading: false, adviser: action.payload.data, listsAdviser: action.payload.data.data }
    case ADVISER_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adviserSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADVISER_SAVE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case ADVISER_SAVE_SUCCESS:
      message.success({ content: 'Insert success', key });
      return{ ...state, loading: false }
    case ADVISER_SAVE_VALIDATION:
      message.error({ content: action.payload.email || action.payload.nik || 'Mohon cek kembali Data!', key });
      return{ ...state, loading: false, validation: action.payload }
    case ADVISER_SAVE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adviserEditReducer = (state = {adviser:{}}, action) => {
  switch (action.type) {
    case ADVISER_EDIT_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ADVISER_EDIT_SUCCESS:
      return{ ...state, loading: false, adviser: action.payload.data }
    case ADVISER_EDIT_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adviserUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADVISER_UPDATE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case ADVISER_UPDATE_SUCCESS:
      message.success({ content: 'Update success', key });
      return{ ...state, loading: false }
    case ADVISER_UPDATE_VALIDATION:
      message.error({ content: action.payload.email || action.payload.nik || 'Mohon cek kembali Data!', key });
      return{ ...state, loading: false, validation: action.payload }
    case ADVISER_UPDATE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adviserDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case ADVISER_DELETE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [] }
    case ADVISER_DELETE_SUCCESS:
      message.success({ content: 'Delete success', key });
      return{ ...state, loading: false }
    case ADVISER_DELETE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

//=================================  Principal  ============================================

export const principalListReducer = (state = {principal:[], listsPrincipal:[]}, action) => {
  switch (action.type) {
    case PRINCIPAL_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case PRINCIPAL_LIST_SUCCESS:
      return{ ...state, loading: false, principal: action.payload.data, listsPrincipal: action.payload.data.data }
    case PRINCIPAL_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const principalbyofficeListReducer = (state = {listsPrincipalbyoffice:[]}, action) => {
  switch (action.type) {
    case PRINCIPAL_BY_OFFICE_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case PRINCIPAL_BY_OFFICE_LIST_SUCCESS:
      return{ ...state, loading: false, listsPrincipalbyoffice: action.payload.data }
    case PRINCIPAL_BY_OFFICE_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const principalSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRINCIPAL_SAVE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case PRINCIPAL_SAVE_SUCCESS:
      message.success({ content: 'Insert success', key });
      return{ ...state, loading: false }
    case PRINCIPAL_SAVE_VALIDATION:
      message.error({ content: 'Please fill all required field', key });
      return{ ...state, loading: false, validation: action.payload }
    case PRINCIPAL_SAVE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const principalEditReducer = (state = {principal:{}}, action) => {
  switch (action.type) {
    case PRINCIPAL_EDIT_REQUEST:
      return{ ...state, loading: true, error: [] }
    case PRINCIPAL_EDIT_SUCCESS:
      return{ ...state, loading: false, principal: action.payload.data }
    case PRINCIPAL_EDIT_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const principalUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRINCIPAL_UPDATE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case PRINCIPAL_UPDATE_SUCCESS:
      message.success({ content: 'Update success', key });
      return{ ...state, loading: false }
    case PRINCIPAL_UPDATE_VALIDATION:
      message.error({ content: 'Please fill all required field', key });
      return{ ...state, loading: false, validation: action.payload }
    case PRINCIPAL_UPDATE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const principalDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PRINCIPAL_DELETE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [] }
    case PRINCIPAL_DELETE_SUCCESS:
      message.success({ content: 'Delete success', key });
      return{ ...state, loading: false }
    case PRINCIPAL_DELETE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

//=================================  Admin  ============================================

export const adminListReducer = (state = {admin:[], listsAdmin:[]}, action) => {
  switch (action.type) {
    case ADMIN_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ADMIN_LIST_SUCCESS:
      return{ ...state, loading: false, admin: action.payload.data, listsAdmin: action.payload.data.data }
    case ADMIN_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_SAVE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case ADMIN_SAVE_SUCCESS:
      message.success({ content: 'Insert success', key });
      return{ ...state, loading: false }
    case ADMIN_SAVE_VALIDATION:
      message.error({ content: 'Please fill all required field', key });
      return{ ...state, loading: false, validation: action.payload }
    case ADMIN_SAVE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state;
  }
}

export const adminEditReducer = (state = {admin:{}}, action) => {
  switch (action.type) {
    case ADMIN_EDIT_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ADMIN_EDIT_SUCCESS:
      return{ ...state, loading: false, admin: action.payload.data }
    case ADMIN_EDIT_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_UPDATE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case ADMIN_UPDATE_SUCCESS:
      message.success({ content: 'Update success', key });
      return{ ...state, loading: false }
    case ADMIN_UPDATE_VALIDATION:
      message.error({ content: 'Please fill all required field', key });
      return{ ...state, loading: false, validation: action.payload }
    case ADMIN_UPDATE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_DELETE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [] }
    case ADMIN_DELETE_SUCCESS:
      message.success({ content: 'Delete success', key });
      return{ ...state, loading: false }
    case ADMIN_DELETE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}


//=================================  CSM  ============================================

export const csmListReducer = (state = {csm:[], listsCsm:[]}, action) => {
  switch (action.type) {
    case CSM_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case CSM_LIST_SUCCESS:
      return{ ...state, loading: false, csm: action.payload.data, listsCsm: action.payload.data.data }
    case CSM_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const csmSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case CSM_SAVE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case CSM_SAVE_SUCCESS:
      message.success({ content: 'Insert success', key });
      return{ ...state, loading: false }
    case CSM_SAVE_VALIDATION:
      message.error({ content: 'Please fill all required field', key });
      return{ ...state, loading: false, validation: action.payload }
    case CSM_SAVE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const csmEditReducer = (state = {csm:{}}, action) => {
  switch (action.type) {
    case CSM_EDIT_REQUEST:
      return{ ...state, loading: true, error: [] }
    case CSM_EDIT_SUCCESS:
      return{ ...state, loading: false, csm: action.payload.data }
    case CSM_EDIT_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const csmUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CSM_UPDATE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case CSM_UPDATE_SUCCESS:
      message.success({ content: 'Update success', key });
      return{ ...state, loading: false }
    case CSM_UPDATE_VALIDATION:
      message.error({ content: 'Please fill all required field', key });
      return{ ...state, loading: false, validation: action.payload }
    case CSM_UPDATE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const csmDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case CSM_DELETE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [] }
    case CSM_DELETE_SUCCESS:
      message.success({ content: 'Delete success', key });
      return{ ...state, loading: false }
    case CSM_DELETE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

//=================================  Admin Branch ============================================

export const adminbranchListReducer = (state = {adminbranch:[], listsAdminBranch:[]}, action) => {
  switch (action.type) {
    case ADMIN_BRANCH_LIST_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ADMIN_BRANCH_LIST_SUCCESS:
      return{ ...state, loading: false, adminbranch: action.payload.data, listsAdminBranch: action.payload.data.data }
    case ADMIN_BRANCH_LIST_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminbranchSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_BRANCH_SAVE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case ADMIN_BRANCH_SAVE_SUCCESS:
      message.success({ content: 'Insert success', key });
      return{ ...state, loading: false }
    case ADMIN_BRANCH_SAVE_VALIDATION:
      message.error({ content: 'Please fill all required field', key });
      return{ ...state, loading: false, validation: action.payload }
    case ADMIN_BRANCH_SAVE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminbranchEditReducer = (state = {adminbranch:{}}, action) => {
  switch (action.type) {
    case ADMIN_BRANCH_EDIT_REQUEST:
      return{ ...state, loading: true, error: [] }
    case ADMIN_BRANCH_EDIT_SUCCESS:
      return{ ...state, loading: false, adminbranch: action.payload.data }
    case ADMIN_BRANCH_EDIT_FAIL:
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminbranchUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_BRANCH_UPDATE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [], validation: [] }
    case ADMIN_BRANCH_UPDATE_SUCCESS:
      message.success({ content: 'Update success', key });
      return{ ...state, loading: false }
    case ADMIN_BRANCH_UPDATE_VALIDATION:
      message.error({ content: 'Please fill all required field', key });
      return{ ...state, loading: false, validation: action.payload }
    case ADMIN_BRANCH_UPDATE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminbranchDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_BRANCH_DELETE_REQUEST:
      message.loading('Loading...', key);
      return{ ...state, loading: true, error: [] }
    case ADMIN_BRANCH_DELETE_SUCCESS:
      message.success({ content: 'Delete success', key });
      return{ ...state, loading: false }
    case ADMIN_BRANCH_DELETE_FAIL:
      message.error({ content: action.payload, key });
      return{ ...state, loading: false, error: action.payload }
    default:
      return state
  }
}